module.exports = __webpack_public_path__ + "img/plane.cbfad605.svg";